export const DATA_PROVIDERS_REPORT = '/measurements/reports/variable';
export const DATA_PROVIDERS_GET_MEASUREMENTS = '/measurements/';

export const DATA_PROVIDERS_GET_CATASTRO = '/catastro/';
export const DATA_PROVIDERS_ADD_CATASTRO = '/catastro/';


export const DATA_PROVIDERS_GET_SITES = '/sites/';

export const DATA_PROVIDERS_GET_PROVIDERS = '/provider/';
export const DATA_PROVIDERS_GET_PROVIDERS_OPTIONS = '/provider/options';
export const DATA_PROVIDERS_GET_MEASUREMENTS_QUERY = '/measurements/query';
export const DATA_PROVIDERS_GET_INCIDENTS_QUERY = '/incidents/query';
export const DATA_PROVIDERS_GET_MEASUREMENTS_DETAIL_QUERY =
	'/measurements-detail/query';
